import { Anchor, Button, Paragraph, Text, TextButton } from '@zillow/constellation';

import type { TextStyledComponentProps } from '../../model/TextStyledComponent';
import type { ComponentType } from 'react';

const TextMap = {
  text: Text,
  paragraph: Paragraph,
} as const;
//  TODO: for future use cases - work with BE to determine how Button and TextButton click handlers will be defined
//  No use case exists yet for Button or TextButton
const CTAMap = {
  anchor: Anchor,
  button: Button,
  textButton: TextButton,
} as const;

type Props = {
  styledComponentContent: TextStyledComponentProps;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

type ComponentProps =
  | React.ComponentProps<typeof Text>
  | React.ComponentProps<typeof Paragraph>
  | React.ComponentProps<typeof Anchor>;

export const TextStyledComponent = ({ styledComponentContent, csEventsHandler, csEventsIdMap }: Props) => {
  if (!styledComponentContent.type) {
    styledComponentContent.type = 'text';
  }

  const DynamicTextComponent: ComponentType<ComponentProps> = styledComponentContent.ctaType
    ? CTAMap[styledComponentContent.ctaType as keyof typeof CTAMap]
    : TextMap[styledComponentContent.type as keyof typeof TextMap];

  const anchorProps =
    styledComponentContent.ctaType === 'anchor'
      ? {
          href: styledComponentContent.url,
          target: '_blank',
          onClick: csEventsHandler ? () => csEventsHandler(styledComponentContent) : undefined,
          ['data-eventid']: csEventsIdMap?.[styledComponentContent.text],
        }
      : null;

  return (
    <DynamicTextComponent data-testid="TextStyledComponent" {...styledComponentContent.styles} {...anchorProps}>
      {styledComponentContent.text}
    </DynamicTextComponent>
  );
};
